export { default } from "./GenreCard";
